import React from 'react';
import Svg from '../Svg';

const IconMoonEclipse = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 12C1 5.92487 5.92487 1 12 1C13.7264 1 15.3625 1.3984 16.8189 2.10921C17.2443 2.31682 17.4659 2.79426 17.3498 3.25315C17.2337 3.71205 16.8117 4.02669 16.3388 4.00703C16.2265 4.00236 16.1136 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20C16.1135 20 16.2265 19.9976 16.3388 19.993C16.8117 19.9733 17.2337 20.2879 17.3498 20.7468C17.4659 21.2057 17.2443 21.6832 16.8189 21.8908C15.3625 22.6016 13.7264 23 12 23C5.92487 23 1 18.0751 1 12ZM11.6197 3.00789C6.82551 3.2072 3 7.15685 3 12C3 16.8432 6.82551 20.7928 11.6197 20.9921C8.29227 19.3682 6 15.9518 6 12C6 8.04821 8.29226 4.63181 11.6197 3.00789ZM19.4008 5.2009C19.8423 4.86903 20.4692 4.95786 20.8011 5.39932C23.7336 9.30015 23.733 14.703 20.7992 18.6032C20.4672 19.0445 19.8403 19.1332 19.3989 18.8012C18.9576 18.4692 18.8689 17.8423 19.2009 17.4009C21.5992 14.2126 21.5997 9.78996 19.2024 6.60113C18.8706 6.15967 18.9594 5.53277 19.4008 5.2009Z"
    />
  </Svg>
);

export default IconMoonEclipse;
